module.exports = __webpack_public_path__ + "img/star.99d1ab30.svg";